import './_bootstrap';
import { App } from './_vue'
import './utils/google-maps'

window.app = new App({
    el: '#app',
})
